import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <>
        <footer>
        <div className="container-fluid footer"> 
        <div class="footer-copyright text-center py-3 footer-A">Made with 👣 by Noobie 
        </div>
  </div>
        </footer>
           
        </>
    )
}

export default Footer
